import { all } from "redux-saga/effects";

import {
  PortalEnable,
  ClientSaga,
  LoginEmailCheck,
  LoginPassWordSet,
  PasswordResetEmailCheck,
  SignUp,
  Logo,
  VzPortLogCheck,
  GetProviderStatus,
} from "./PreLogin/PreLoginWatchers";

import { LoginSaga } from "./Login/LoginSagaWatchers";
import { MembershipSagaWatcher } from "./Membership/MembershipSagaWatcher";

import {
  UserDetails,
  NotificationDetails,
  NotificationUpdate,
  NotificationDelete,
} from "./TopNavbar/TopNavbarSagaWatchers";

import {
  PayBalSaga,
  Medications,
  WelcomePop,
  FirstLogin,
  FirstUserLogin,
} from "./DashBoard/DashboardSagaWatchers";

import {
  upcomingAppointmentsSaga,
  getProviderAvailablitySaga,
  EditAppointmentSaga,
  GetProviderSaga,
  GetFacilitySaga,
  SaveAppointmentSaga,
  SaveWaitListAppointmentSaga,
  EditWaitListAppointmentSaga,
  CancelApptSaga,
  deleteWaitlistSaga,
  PastApptSaga,
  getPortalAppAvailablitySaga,
  getOnsiteAppReqSaga,
  BillingFacilitySaga,
} from "./Appointments/AppointmentsSagaWatchers";
import {
  CardDetails,
  AddCardDetail,
  EditCardDetail,
  RemoveCardDetails,
  InvoiceList,
  OneInvoiceList,
  MakePayment,
  PaymentHistory,
} from "./Billing/BillingSagaWatchers";
import {
  DocumentLists,
  InsertDocuments,
  UpdateDocument,
  DeleteDocument,
  DownloadDocument,
  PreViewDocument,
  ViewEditDocument,
  SignDocument,
  FirstSaveDocument,
  DeleteTempDocument,
  DeleteLabDocument,
  DownloadCreadential,
  DownloadLabCreadential,
} from "./Documents/DocumentsSagaWatchers";
import { ListSaga } from "./HealthProfile/HealthProfileSagaWatchers";
import { HealthScreeningListSaga } from "./HealthProfile/HealthScreeningSagaWatchers";
import {
  GetLifestyleEntriesWatcher,
  AddLifestyleEntryWatcher,
  GetDietRecommendationsWatcher,
  DeleteLifestyleEntryWatcher,
  GetLifestyleConfigWatcher,
} from "./HealthProfile/LifestyleSagaWatchers";
import {
  HomeWorkSaga,
  UpdateWatchedSaga,
} from "./HomeWork/HomeWorkSagaWatchers";
import {
  ProviderListSaga,
  MessagerListSaga,
  MessageSendSaga,
  PreviewDownloadSagaM,
  UnreadCountUpdateSaga,
  PinchatSaga,
} from "./Messenger/MessengerSagaWatchers";
import {
  PatGenderDetails,
  PatMaritalStatus,
  PatLangDetails,
  PatRaceDetails,
  PatientProfileUpdate,
  PatientProfileRemove,
  PatientDetailUpdate,
  EmailExist,
  PhoneExist,
  ProfileUpdateStatus,
  PatientStatus,
  FeedbackInsert,
  ResetPassword,
  CheckPatPortalPassword,
  AccountDeleteWatcher,
  ClinicalInfoSignedForm,
} from "./Settings/SettingsSagaWatchers";
import { AdditionalInfoSagaWatchers } from "./AdditionalInfo/AdditionalInfoSagaWatchers";
import {
  GetInsuranceDetails,
  GetSingleInsuranceDetail,
  InsuranceStatusChanged,
  PayerName,
  ProfileRemoved,
  ProfileUploaded,
  SingleInsuranceDetail,
  DeleteInsuranceRequest,
  RelationShipTypes,
} from "./Insurance/InsuranceSagaWatchers";
import { RefundListWatcher } from "./Refund/RefundSagaWatchers";

export default function* rootSaga() {
  return yield all([
    //PreLogin
    PortalEnable(),
    ClientSaga(),
    LoginEmailCheck(),
    LoginPassWordSet(),
    PasswordResetEmailCheck(),
    SignUp(),
    Logo(),
    VzPortLogCheck(),
    //PreLogin

    //TopNavbar //
    UserDetails(),
    NotificationDetails(),
    NotificationUpdate(),
    NotificationDelete(),
    //TopNavbar //

    // DashBoard //
    PayBalSaga(),
    Medications(),
    // DashBoard //

    // Appointments//
    PastApptSaga(),
    upcomingAppointmentsSaga(),
    CancelApptSaga(),
    deleteWaitlistSaga(),
    getProviderAvailablitySaga(),
    EditAppointmentSaga(),
    GetProviderSaga(),
    GetFacilitySaga(),
    SaveAppointmentSaga(),
    SaveWaitListAppointmentSaga(),
    EditWaitListAppointmentSaga(),
    getPortalAppAvailablitySaga(),
    getOnsiteAppReqSaga(),
    BillingFacilitySaga(),
    // Appointments//

    // Login //
    LoginSaga(),
    WelcomePop(),
    FirstLogin(),
    FirstUserLogin(),
    // Login //

    // Billing //
    CardDetails(),
    AddCardDetail(),
    EditCardDetail(),
    RemoveCardDetails(),
    InvoiceList(),
    OneInvoiceList(),
    MakePayment(),
    PaymentHistory(),
    // Billing //

    // Documents //
    DocumentLists(),
    InsertDocuments(),
    UpdateDocument(),
    DeleteDocument(),
    DownloadDocument(),
    PreViewDocument(),
    ViewEditDocument(),
    SignDocument(),
    FirstSaveDocument(),
    DeleteTempDocument(),
    DeleteLabDocument(),
    DownloadCreadential(),
    DownloadLabCreadential(),
    // Documents //

    // Health Profile //
    ListSaga(),
    HealthScreeningListSaga(),
    GetLifestyleEntriesWatcher(),
    AddLifestyleEntryWatcher(),
    GetDietRecommendationsWatcher(),
    DeleteLifestyleEntryWatcher(),
    GetLifestyleConfigWatcher(),
    // Health Profile //

    // Home Work //
    HomeWorkSaga(),
    UpdateWatchedSaga(),
    // Home Work //

    // Message //
    ProviderListSaga(),
    MessagerListSaga(),
    MessageSendSaga(),
    PreviewDownloadSagaM(),
    UnreadCountUpdateSaga(),
    GetProviderStatus(),
    PinchatSaga(),
    // Message //

    // Settings //
    PatGenderDetails(),
    PatMaritalStatus(),
    PatLangDetails(),
    PatRaceDetails(),
    PatientProfileUpdate(),
    PatientProfileRemove(),
    PatientDetailUpdate(),
    EmailExist(),
    PhoneExist(),
    ProfileUpdateStatus(),
    PatientStatus(),
    FeedbackInsert(),
    ResetPassword(),
    CheckPatPortalPassword(),
    AccountDeleteWatcher(),
    ClinicalInfoSignedForm(),
    // Settings //

    //Insurance
    SingleInsuranceDetail(),
    GetInsuranceDetails(),
    PayerName(),
    GetSingleInsuranceDetail(),
    InsuranceStatusChanged(),
    DeleteInsuranceRequest(),
    RelationShipTypes(),
    //Insurance
    MembershipSagaWatcher(),
    //Refund
    RefundListWatcher(),
    
    // AdditionalInfo
    AdditionalInfoSagaWatchers(),
  ]);
}
